import { useLayoutEffect, useRef, useState } from 'react';
import { translate } from '@chaika/i18n/helper';
import styles from './TableTruncatedText.module.scss';
import classnames from 'classnames';

interface TableTruncatedTextProps {
    showMore: 'click' | 'text-button';
    maxLines: number;
    value: string;
}

export const TableTruncatedText = ({ showMore, maxLines, value }: TableTruncatedTextProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isClamped, setIsClamped] = useState(false);

    const truncatedRef = useRef<HTMLParagraphElement>(null);

    useLayoutEffect(() => {
        const element = truncatedRef.current;

        if (!element || !(element instanceof HTMLElement)) return;

        setIsClamped(element.scrollHeight > element.clientHeight);
    }, [value, maxLines]);

    const textClickable = showMore === 'click' && isClamped;

    return (
        <div className={classnames(styles.root, textClickable && styles.clickable)}>
            <p
                ref={truncatedRef}
                title={value}
                style={
                    isOpen
                        ? {
                              overflow: 'hidden',
                              display: '-webkit-box',
                              // This property gets removed from SCSS for whatever reason, so the whole truncate-related block is defined here
                              WebkitBoxOrient: 'vertical',
                              WebkitLineClamp: String(maxLines),
                          }
                        : undefined
                }
                onClick={
                    textClickable
                        ? event => {
                              event.stopPropagation();
                              setIsOpen(prev => !prev);
                          }
                        : undefined
                }
            >
                {value}
            </p>
            {isClamped && showMore === 'text-button' ? (
                <div
                    className={styles.icon}
                    onClick={e => {
                        setIsOpen(prev => !prev);
                        e.stopPropagation();
                    }}
                >
                    {translate(!isOpen ? 'collapse' : 'showFull')}
                </div>
            ) : null}
        </div>
    );
};
